import { render, staticRenderFns } from "./AdminAttendance.vue?vue&type=template&id=f84a45a8&scoped=true&"
import script from "./AdminAttendance.vue?vue&type=script&lang=js&"
export * from "./AdminAttendance.vue?vue&type=script&lang=js&"
import style0 from "./AdminAttendance.vue?vue&type=style&index=0&id=f84a45a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84a45a8",
  null
  
)

export default component.exports